/* WALLET-01 winner, deployed Oct 20 2026 (was Intelligems variant B). Shows Shop Pay + Apple Pay under the UpCart
 * drawer Checkout button, plus a caption. Fetches sections/pkg-express.liquid (Shopify accelerated checkout buttons)
 * via the Section Rendering API, so sections/pkg-express.liquid must stay in the theme. PayPal is stripped before render.
 * Debug: add ?pkgdebug=1 to the URL for a status box (sticky for the tab).
 */
(function () {
  if (window.__pkgWalletB) return;
  window.__pkgWalletB = true;

  var HOST_ID = 'upCart';
  var BOX_ID = 'pkg-express';
  var PH_ID = 'pkg-express-ph';
  var STYLE_ID = 'pkg-express-style';
  var CAPTION = 'One tap, address and card pre-filled';
  var SECTION = 'pkg-express';
  var CHECKOUT_SEL = '[class*="Footer__checkoutButton"], .upcart-checkout-button-container, [class*="CustomButton__fullWidth"]';

  var DEBUG = /[?&]pkgdebug=1/.test(location.search);
  try { if (DEBUG) sessionStorage.setItem('pkgdebug', '1'); else DEBUG = sessionStorage.getItem('pkgdebug') === '1'; } catch (e) {}
  var dbgEl = null, lastMsg = '';
  function dbg(msg) {
    if (!DEBUG) return;
    if (!dbgEl) {
      dbgEl = document.createElement('pre');
      dbgEl.style.cssText = 'position:fixed;left:4px;right:4px;top:4px;z-index:2147483647;margin:0;padding:6px;font:11px/1.35 ui-monospace,monospace;white-space:pre-wrap;background:rgba(255,255,200,.95);color:#000;border:1px solid #999;pointer-events:none';
      (document.body || document.documentElement).appendChild(dbgEl);
    }
    var b = document.getElementById(BOX_ID), c = b && b.querySelector('shopify-accelerated-checkout-cart');
    var r = root(), btn = r && r.querySelector(CHECKOUT_SEL);
    var kids = c ? Array.prototype.map.call(c.children, function (k) { return k.tagName.toLowerCase().replace('shopify-', '') + ':' + Math.round(k.getBoundingClientRect().height); }).join(' ') : '-';
    var txt = 'PKG ' + msg + '\nbox:' + (!!b) + ' cart-el:' + (!!c) + ' wallets:' + (c ? (c.getAttribute('wallet-configs') || '').replace(/[^a-z_,]/g, '').match(/shop_pay|apple_pay|paypal|google_pay/g) : '-') +
      '\nbuttons: ' + kids + '\nel h:' + (c ? Math.round(c.getBoundingClientRect().height) : '-') + ' box h:' + (b ? Math.round(b.getBoundingClientRect().height) : '-') +
      '\ndrawer btn:' + (!!btn) + (btn ? ' w' + Math.round(btn.getBoundingClientRect().width) : '') + ' on:' + (b ? b.classList.contains('pkg-on') : '-') +
      ' theme:' + (window.Shopify && Shopify.theme ? Shopify.theme.id : '?') + ' ApplePaySession:' + (typeof window.ApplePaySession);
    if (txt !== lastMsg) { dbgEl.textContent = txt; lastMsg = txt; }
  }

  var box = null, ph = null, raf = 0, shown = false, refreshT = 0, shownAt = 0;

  function root() { var h = document.getElementById(HOST_ID); return h && h.shadowRoot; }

  function drawerOpen(r) {
    var b = r && r.querySelector(CHECKOUT_SEL);
    if (!b) return null;
    var rc = b.getBoundingClientRect();
    return rc.width > 0 && rc.height > 0 ? b : null;
  }

  var failUntil = 0;
  function buttonsReady() {
    if (!box || Date.now() < failUntil) return false;
    return !!box.querySelector('shopify-accelerated-checkout-cart');
  }

  function ensureBox() {
    box = document.getElementById(BOX_ID);
    if (!box && document.body) {
      box = document.createElement('div');
      box.id = BOX_ID;
      document.body.appendChild(box);
      ensureStyle();
    }
    return !!box;
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '#' + BOX_ID + '{position:absolute;left:-9999px;top:0;width:360px;visibility:hidden;pointer-events:none}' +
      '#' + BOX_ID + ' shopify-paypal-button,#' + BOX_ID + ' shopify-google-pay-button,#' + BOX_ID + ' shopify-amazon-pay-button,' +
      '#' + BOX_ID + ' shopify-venmo-button,#' + BOX_ID + ' shopify-facebook-pay-button,#' + BOX_ID + ' more-payment-options-link{display:none !important}' +
      '#' + BOX_ID + '.pkg-on{display:block !important;position:fixed;z-index:2147483647;box-sizing:border-box;visibility:visible !important;pointer-events:auto !important;' +
      'margin:0;padding:0 0 4px;background:transparent;--shopify-accelerated-checkout-button-block-size:44px;' +
      '--shopify-accelerated-checkout-inline-alignment:stretch;--shopify-accelerated-checkout-row-gap:8px}' +
      '#' + BOX_ID + ' .pkg-caption{font:500 12px/1.3 system-ui,-apple-system,sans-serif;color:#555;text-align:center;margin:6px 0 0}';
    document.head.appendChild(s);
    if (!box.querySelector('.pkg-caption')) {
      var c = document.createElement('p');
      c.className = 'pkg-caption';
      c.textContent = CAPTION;
      box.appendChild(c);
    }
  }

  function removePlaceholder() {
    if (ph && ph.parentNode) ph.parentNode.removeChild(ph);
    ph = null;
  }

  function hide() {
    if (box) box.classList.remove('pkg-on');
    removePlaceholder();
    shown = false; shownAt = 0;
  }

  function place() {
    raf = 0;
    if (!ensureBox()) return;
    var r = root();
    var btn = drawerOpen(r);
    ensureStyle();
    if (!btn || !buttonsReady()) { if (shown) hide(); return; }

    var h = box.getBoundingClientRect().height || 0;
    if (h < 30) h = 104;
    if (box.classList.contains('pkg-on') && shownAt && Date.now() - shownAt > 4000 &&
        box.querySelector('shopify-accelerated-checkout-cart').getBoundingClientRect().height < 20) {
      failUntil = Date.now() + 5000; hide(); dbg('hidden: no wallet buttons rendered'); return;
    }
    ph = r.getElementById ? r.getElementById(PH_ID) : r.querySelector('#' + PH_ID);
    if (!ph) {
      ph = document.createElement('div');
      ph.id = PH_ID;
      ph.setAttribute('aria-hidden', 'true');
      btn.insertAdjacentElement('afterend', ph);
    }
    ph.style.cssText = 'height:' + Math.ceil(h) + 'px;margin:8px 0 0;pointer-events:none';

    var rc = ph.getBoundingClientRect();
    box.style.left = rc.left + 'px';
    box.style.top = rc.top + 'px';
    box.style.width = rc.width + 'px';
    if (!box.classList.contains('pkg-on')) {
      box.classList.add('pkg-on');
      shown = true; shownAt = Date.now();
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'pkg_express_shown' }); } catch (e) {}
    }
  }

  var KEEP = { shop_pay: 1, apple_pay: 1 };
  function keepOnly(cart) {
    try {
      var cfg = JSON.parse(cart.getAttribute('wallet-configs') || '[]');
      cart.setAttribute('wallet-configs', JSON.stringify(cfg.filter(function (w) { return KEEP[w.name]; })));
    } catch (e) {}
    var kids = cart.children;
    for (var i = kids.length - 1; i >= 0; i--) {
      var t = kids[i].tagName.toLowerCase();
      if (t !== 'shop-pay-wallet-button' && t !== 'shopify-apple-pay-button') cart.removeChild(kids[i]);
    }
  }

  function schedule() { if (!raf) raf = requestAnimationFrame(function () { place(); dbg(shown ? 'shown' : 'waiting'); }); }

  function refreshButtons() {
    clearTimeout(refreshT);
    refreshT = setTimeout(function () {
      fetch('/?sections=' + SECTION + '&_=' + Date.now(), { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (j) {
          if (!j || !j[SECTION] || !ensureBox()) { dbg('section fetch empty'); if (!document.body) setTimeout(refreshButtons, 300); return; }
          var cap = box.querySelector('.pkg-caption');
          var tmp = document.createElement('div');
          tmp.innerHTML = j[SECTION];
          var src = tmp.querySelector('#' + BOX_ID) || tmp;
          var cart = src.querySelector('shopify-accelerated-checkout-cart');
          if (!cart) { dbg('no buttons in section'); return; }
          keepOnly(cart);
          while (box.firstChild) box.removeChild(box.firstChild);
          while (src.firstChild) box.appendChild(src.firstChild);
          if (cap) box.appendChild(cap);
          schedule();
        })
        .catch(function (e) { dbg('section fetch failed ' + e); });
    }, 400);
  }

  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(refreshButtons, function () {});
      return p;
    };
  }

  var moRoot = null, mo = new MutationObserver(schedule);
  function attach() {
    var r = root();
    if (r && r !== moRoot) {
      moRoot = r;
      mo.observe(r, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    }
    schedule();
  }
  new MutationObserver(attach).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true, capture: true });
  setInterval(schedule, 1000);
  attach();
  refreshButtons();
})();